
export const handleChangeValue = (e, set) => {
    set(e.floatValue)
}